import React, { useState } from "react";

import Real1 from "../../../assets/img/realisation/ACRO-Filets_mise_en_sécurité.jpg";
import Real2 from "../../../assets/img/realisation/ACRO-Filets_mise_en_sécurité(1).jpg";
import Real3 from "../../../assets/img/realisation/ACRO-Mise_en_place_filet_anti-chute.jpg";
import Real5 from "../../../assets/img/realisation/ACRO-NETTOYAGE_VITRES.png";
import Real6 from "../../../assets/img/realisation/ACRO-Pose_système_anti_volatiles.png";
import Real7 from "../../../assets/img/realisation/ACRO-Purge_corniche.jpg";
import Real8 from "../../../assets/img/realisation/ACRO-Purge_façade.png";
import Real9 from "../../../assets/img/realisation/ACRO-Remplacement_colonne_EU.jpg";
import Real10 from "../../../assets/img/realisation/ACRO-Remplacement_colonne_EU(1).jpg";
import Real11 from "../../../assets/img/realisation/CHEMISAGE-GROSSE_MACHINE.png";
import Real12 from "../../../assets/img/realisation/CHEMISAGE-Mise_en_place_chantier.jpg";
import Real13 from "../../../assets/img/realisation/CHEMISAGE-Passage_cam.jpg";
import Real14 from "../../../assets/img/realisation/CHEMISAGE-Résine_colonne_EP.jpg";
import Real15 from "../../../assets/img/realisation/CHEMISAGE-Résine.jpg";
import Real16 from "../../../assets/img/realisation/CHEMISAGE-Résine(1).jpg";
import Real17 from "../../../assets/img/realisation/PLOMB-Plancher_chauffant.jpg";
import Real18 from "../../../assets/img/realisation/PLOMB-Pose_manomètre.png";
import Real19 from "../../../assets/img/realisation/PLOMB-Recherche_de_fuite_fluorescéine_(1).png";
import Real20 from "../../../assets/img/realisation/PLOMB-Recherche_de_fuite_fluorescéine.png";
import Real21 from "../../../assets/img/realisation/PLOMB-SDB_(1).jpg";
import Real22 from "../../../assets/img/realisation/PLOMB-SDB_(2).png";
import Real23 from "../../../assets/img/realisation/PLOMB-SDB.jpg";
import Real24 from "../../../assets/img/realisation/PLOMB-Testeur_humidité.png";

import repairIco from "../../../assets/img/ico/worker.png";
import plumbingIco from "../../../assets/img/ico/plumbing.svg";
import zincIco from "../../../assets/img/ico/zinc.svg";

import "./realisation.css";

export default function Realisation() {
  // 1) données brutes
  const items = [
    {
      name: "Pose de filets de mise en sécurité",
      img: Real2,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Pose de filets de mise en sécurité ",
      img: Real1,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Mise en place filet anti-chute",
      img: Real3,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    // {
    //   name: "Nettoyage de vitres",
    //   img: Real4,
    //   tag: "Acrobatique",
    //   maps: "Nice",
    //   ico: repairIco,
    // },
    {
      name: "Nettoyage de vitres",
      img: Real5,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Pose système anti volatiles",
      img: Real6,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Purge corniche",
      img: Real7,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Purge façade",
      img: Real8,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Remplacement colonne EU",
      img: Real9,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Remplacement colonne EU",
      img: Real10,
      tag: "Acrobatique",
      maps: "Nice",
      ico: repairIco,
    },
    {
      name: "Chemisage intégrale colonne EP ",
      img: Real11,
      tag: "Chemisage",
      maps: "Nice",
      ico: zincIco,
    },
    {
      name: "Mise en place chantier chemisage",
      img: Real12,
      tag: "Chemisage",
      maps: "Nice",
      ico: zincIco,
    },
    {
      name: "Passage de caméra",
      img: Real13,
      tag: "Chemisage",
      maps: "Nice",
      ico: zincIco,
    },
    {
      name: "Résine colonne EP",
      img: Real14,
      tag: "Chemisage",
      maps: "Nice",
      ico: zincIco,
    },
    {
      name: "Chemisage spray en cours - 1ier passage ",
      img: Real15,
      tag: "Chemisage",
      maps: "Nice",
      ico: zincIco,
    },
    {
      name: "Chemisage spray en cours - 2ème passage",
      img: Real16,
      tag: "Chemisage",
      maps: "Nice",
      ico: zincIco,
    },
    {
      name: "Recherche de fuite par caméra thermique",
      img: Real24,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
    {
      name: "Recherche de fuite sur alimentation",
      img: Real18,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
    {
      name: "Recherche de fuite sur EU ",
      img: Real19,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
    {
      name: "Recherche de fuite d’étanchéité",
      img: Real20,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
    {
      name: "Rénovation salle de bain complète",
      img: Real21,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
    {
      name: "Rénovation salle de bain complète",
      img: Real22,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
    {
      name: "Rénovation salle de bain complète ",
      img: Real23,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
    {
      name: "Plancher chauffant",
      img: Real17,
      tag: "Plomberie",
      maps: "Nice",
      ico: plumbingIco,
    },
  ];

  // 2) extraire dynamiquement les tags uniques
  const allTags = Array.from(new Set(items.map((it) => it.tag)));
  const filters = ["Tout voir", ...allTags];

  // 3) state du filtre actif
  const [active, setActive] = useState("Tout voir");

  // 4) items filtrés
  const displayed =
    active === "Tout voir" ? items : items.filter((it) => it.tag === active);

  console.log("items =", items);
  console.log("filters =", filters);
  console.log("active =", active);
  console.log("displayed =", displayed);

  return (
    <section className="Realisation" id="realisation">
      <h2>Nos réalisations</h2>
      <p>
        Spécialistes des interventions en plomberie classique, chemisage, mais
        également des travaux en acrobatiques, nous accompagnons aussi bien les
        copropriétés, les syndics, que les professionnels et particuliers, avec
        une approche fondée sur la réactivité, la transparence et la qualité.
      </p>

      {/* --- barre de filtres --- */}
      <nav className="filters">
        {filters.map((f) => (
          <button
            key={f}
            className={f === active ? "active" : ""}
            onClick={() => setActive(f)}
          >
            {f}
          </button>
        ))}
      </nav>

      {/* --- grille des réalisations --- */}
      <div className="grid">
        {displayed.map(({ name, img, maps, ico, tag }, i) => (
          <div className="card" key={i}>
            <img src={img} alt={name} />
            <div className="info">
              <h3>{name}</h3>
              <footer className="footer">
                <span>
                  <svg
                    width="19"
                    height="26"
                    viewBox="0 0 19 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.16533 25.2328C8.1637 24.1742 7.21683 23.2276 6.32649 22.224C4.48575 20.1505 2.8252 17.9252 1.57978 15.3717C0.818398 13.8085 0.24427 12.1808 0.125912 10.3957C-0.147903 6.25243 2.23164 2.25717 5.86366 0.773651C11.2304 -1.42128 17.0141 2.06936 18.0528 8.13434C18.4044 10.1832 18.0564 12.1353 17.3038 14.0248C16.1821 16.8439 14.4985 19.2626 12.5836 21.4974C11.506 22.7571 10.3525 23.9428 9.16533 25.2328ZM9.15297 13.7175C11.1509 13.7137 12.7744 11.9703 12.7762 9.82275C12.7779 7.67715 11.1545 5.92614 9.15827 5.92044C7.14617 5.91475 5.51035 7.67335 5.51741 9.83603C5.52271 11.9797 7.15324 13.7213 9.15297 13.7175Z"
                      fill="black"
                    />
                  </svg>
                  {maps}
                </span>
                <div className={"ico " + tag}>
                  {" "}
                  <img src={ico} alt="" />{" "}
                </div>
              </footer>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
